import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from "@mui/styles";
import clsx from 'clsx';
import msgSuccess from '../../../assets/images/green_check.png';
import msgError from '../../../assets/images/error.png';
import msgWarning from '../../../assets/images/ha_warning.png';
import msgInfo from '../../../assets/images/notifications_info.svg';



/**
 * @param {Object} props
 * @param {Node} [props.children]
 * @param {('note'|'warning'|'error')} [props.variant]
 * @param {Object} [props.style]
 * @param {String} [props.className]
 */
function SMCNote({
                     children,
                     variant,
                     className,
                     style,
                     iconStyle,
                 }) {
    const classes = useStyles();

    const varientClass = useMemo(() => {
        switch (variant) {
            case 'warning':
                return classes.warning;
            case 'error':
                return classes.error;
            case 'success':
                return classes.success;
            case 'info':
            case 'note':
            default:
                return classes.note; // Note is the default
        }
    }, [variant, classes]);

    const noteIcon = useMemo(() => {
        switch (variant) {
            case 'warning':
                return msgWarning;
            case 'error':
                return msgError;
            case 'success':
                return msgSuccess;
            case 'info':
            case 'note':
            default:
                return msgInfo;
        }
    }, [variant]);

    return (
        <div style={style} className={clsx(classes.root, varientClass, className)}>
            <img src={noteIcon} alt="" className={classes.icon} style={iconStyle || {verticalAlign: 'middle'}}/>
            <span className={classes.noteTxt}>{children}</span>
        </div>
    );
}

const useStyles = makeStyles({
    root: {
        minHeight: '30px',
        margin: '5px 5px 5px 0',
        border: '1px solid #d8dee1',
        textAlign: 'left',
        opacity: '1',
        boxSizing: 'border-box'
    },
    icon: {
        margin: '5px 10px 5px'
    },
    note: {
        backgroundColor: '#EBF4FB',
        border: '1px solid #3b8fd6'
    },
    warning: {
        background: '#FFB72D1A 0% 0% no-repeat padding-box',
        border: '1px solid #FFB72D',
    },
    error: {
        background: '#F24E4E1A 0% 0% no-repeat padding-box',
        border: '1px solid #F24E4E'
    },
    success: {
        background: '#56B40A1A 0% 0% no-repeat padding-box',
        border: '1px solid #56b40a',
    },
    noteTxt: {
        textAlign: 'left',
        font: 'normal normal normal 13px Open Sans',
        letterSpacing: '0px',
        color: '#333333',
        opacity: '1',
        verticalAlign: 'middle'
    },
})

SMCNote.propTypes = {
    variant: PropTypes.oneOf(['note', 'warning', 'error']),
    children: PropTypes.node,
    style: PropTypes.object,
    className: PropTypes.string,
    iconStyle: PropTypes.object
}

export default SMCNote;